import React from 'react'
import { LoadingButton } from '@mui/lab'
import { CircularProgress } from '@mui/material'
import { AI_TOOL_LOADING_SIZES } from './aiToolLoadingSizes'

const runButtonSx = {
  fontFamily: "'Anton', sans-serif",
  fontSize: 13,
  letterSpacing: '3px',
  textTransform: 'uppercase',
  fontWeight: 400,
  py: 2,
  background: 'var(--gold-gradient)',
  color: 'var(--text-on-primary)',
  boxShadow: '0 4px 24px rgba(251, 189, 35, 0.25)',
  '&:hover': {
    background: 'var(--gold-gradient)',
    opacity: 0.9,
    transform: 'translateY(-1px)',
    boxShadow: '0 4px 24px rgba(251, 189, 35, 0.25)',
  },
  '&.Mui-disabled': {
    opacity: 0.5,
    color: 'var(--text-on-primary)',
    background: 'var(--gold-gradient)',
  },
}

function AiToolRunButton({
  loading = false,
  type = 'button',
  onClick,
  children,
  disabled,
  sx,
}) {
  return (
    <LoadingButton
      fullWidth
      variant="contained"
      type={type}
      loading={loading}
      disabled={disabled}
      onClick={onClick}
      loadingPosition="start"
      loadingIndicator={
        <CircularProgress
          color="inherit"
          size={AI_TOOL_LOADING_SIZES.primary}
        />
      }
      disableElevation
      sx={{
        mt: type === 'submit' ? 1 : 0,
        ...runButtonSx,
        ...sx,
      }}
    >
      {children}
    </LoadingButton>
  )
}

export default AiToolRunButton
